import { Box, Chip, Divider, Stack, Typography } from '@mui/material'
import { Check } from 'lucide-react'
import type { Product } from '@/content/types'

function Row({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <Box sx={{ py: 2.5 }}>
      <Typography variant="overline" sx={{ color: 'text.secondary', display: 'block', mb: 1.25 }}>
        {label}
      </Typography>
      {children}
    </Box>
  )
}

function Chips({ items }: { items: string[] }) {
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {items.map((item) => (
        <Chip key={item} label={item} size="small" variant="outlined" />
      ))}
    </Stack>
  )
}

/** Material / sizes / applications / features / certifications for the detail page. */
export function SpecTable({ product }: { product: Product }) {
  return (
    <Stack divider={<Divider />}>
      <Row label="Material">
        <Typography variant="body1">{product.materials.join(' · ')}</Typography>
      </Row>
      {/* Hidden until finalized — restore when client confirms sizes.
      <Row label="Available Sizes">
        <Chips items={product.availableSizes} />
      </Row>
      */}
      <Row label="Recommended Applications">
        <Chips items={product.applications} />
      </Row>
      {product.features.length > 0 && (
        <Row label="Features">
          <Stack spacing={1}>
            {product.features.map((f) => (
              <Stack key={f} direction="row" spacing={1.25} alignItems="flex-start">
                <Box sx={{ color: 'primary.main', mt: '2px' }}>
                  <Check size={16} />
                </Box>
                <Typography variant="body2">{f}</Typography>
              </Stack>
            ))}
          </Stack>
        </Row>
      )}
      {/* Hidden until finalized — restore when client confirms certifications.
      {product.certifications.length > 0 && (
        <Row label="Certifications">
          <Chips items={product.certifications} />
        </Row>
      )}
      */}
    </Stack>
  )
}
